<template>
    <div>
        <div class="flex items-center justify-center ml-[100px] mb-[30px]">
            <div class="font-Montserrat font-bold text-[32px] text-center">{{ $t('ID-Photo-Maker-Results') }}
            </div>
            <div class="ml-[100px] mb-4">
                <img class="w-full h-full" src="/assets/images/functype/allTools/newImgs/Vector.svg" alt="Vector">
            </div>
        </div>
        <div style="line-height: 26px;" class="text-text-gray text-base text-center mb-[80px] ">{{
            $t('ID-Photo-Maker-Results-desc') }}
        </div>
        <NuxtImg width="1200" height="400" alt="maker" loading="lazy"
            src="/assets/images/functype/allTools/newImgs/ID_photo_maker_resultbg.webp"></NuxtImg>
    </div>
</template>
<script setup>
const { t } = useI18n();

</script>
<style scoped></style>